import React, { Component } from "react";
import { Container } from "reactstrap";
import FooterLink from "./Footer_link";

import Contact from "../WaitlistForm";

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      links: [
        {
          id: 1,
          title: "Services",
          child: [
            { title: "Web Design", link: "#" },
            { title: "Lorem Test", link: "#" },
            { title: "Credit", link: "#" },
            { title: "Ui Design", link: "#" },
          ],
        },
        {
          id: 2,
          title: "Company",
          child: [
            { title: "Features", link: "#" },
            { title: "Faq", link: "#" },
            { title: "Contact us", link: "#" },
          ],
        },
      ],
    };
  }

  render() {
    return (
      <React.Fragment>
        {/* Footer Start */}
        <footer className="section bg-light bg-footer pb-5">
          <Container>
            <Contact />
            <hr className="my-5" />
            {/* Render Footer Link End */}
            <FooterLink />
          </Container>
        </footer>
        {/* Footer End */}
      </React.Fragment>
    );
  }
}

export default Footer;
